import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core';
import { Hearing } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { IconButton, IconTooltip } from 'components';

const useStyles = makeStyles((theme) => ({
  hearing: {
    fontSize: '1.5rem',
    color: theme.palette.greyBlue[700],
  },
}));

const TTSButton = ({ onTTSClick, ttsActive, ttsButtonRef, ...props }) => {
  const classes = useStyles();

  return (
    <IconTooltip id="tts-controls" title="Text-to-Speech Controls" {...props}>
      <IconButton
        aria-controls="tts-controls-menu"
        aria-expanded={ttsActive}
        aria-label="Text-to-Speech Controls"
        isPressed={ttsActive}
        onClick={onTTSClick}
        ref={ttsButtonRef}
      >
        <Hearing className={classes.hearing} />
      </IconButton>
    </IconTooltip>
  );
};

TTSButton.propTypes = {
  onTTSClick: PropTypes.func,
  ttsActive: PropTypes.bool,
  ttsButtonRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export default memo(TTSButton);
